import { DatePipe, registerLocaleData } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Route, RouterModule } from '@angular/router';
import { ClarityModule } from '@clr/angular';
import { CapcodApiModule, LinkDictionary } from 'capcod-api';
import { CapcodClarityFullModule } from 'capcod-clarity';
import { environment } from 'src/environments/environment';
import { AppComponent } from './app.component';
import { WorkflowDictionary } from './core/services/link-dictionary';
import { CapcodTranslateModule } from 'capcod-translate';
import {CapcodToastModule} from "capcod-toast";

registerLocaleData(localeFr);

const routes: Route[] = [
  { path: 'login', loadChildren: () => import('./login/login.module').then(x => x.LoginModule) },
  {
    path: 'main', loadChildren: () => import('./main/main.module')
      .then(x => x.MainModule)
  },
  { path: '**', redirectTo: 'login' },
];

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes),
    BrowserAnimationsModule,
    CapcodClarityFullModule,
    CapcodApiModule.forRoot(environment),
    HttpClientModule,
    CapcodTranslateModule,
    ClarityModule,
    CapcodToastModule
  ],
  providers: [
    DatePipe,
    { provide: LinkDictionary, useClass: WorkflowDictionary },
    { provide: LOCALE_ID, useValue: 'fr' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
